import Tooltip from "@shared/v2/Tooltip";
import { CircleInfoSolidV6 } from "@shared/v2/Icomoon";

const ResultsCount = ({ resultCount, className, limit }) => {
  const areMoreAvailable = resultCount !== null && resultCount >= limit;
  const text = resultCount > 0 ? `Showing ${resultCount} most recent properties` : "No results";

  return (
    <div className={`tw-flex tw-flex-row tw-gap-4px tw-text-12px ${className}`}>
      <span>{text}</span>
      {areMoreAvailable && (
        <Tooltip
          className="tw-flex tw-self-center"
          trigger={<CircleInfoSolidV6 />}
          content={`Showing ${resultCount} most recent properties. To see more, you can change your search size, narrow your search, or adjust your filters.`}
          innerClassName="tw-max-w-[248px]"
          placement="top"
        />
      )}
    </div>
  );
};

export default ResultsCount;
